package com.anjuros.website.templates.template9.modules

import com.anjuros.website.templates.template9.util.ResKey
import com.anjuros.website.templates.template9.util.Template9Res

enum class Template9WhyChoose(
    val icon: String,
    val title: ResKey,
    val description: ResKey
) {
    Passion(
        icon = Template9Res.Icon.why_heart,
        title = ResKey.TEMPLATE9_WHY1_TITLE,
        description = ResKey.TEMPLATE9_WHY1_DESC
    ),
    Safety(
        icon = Template9Res.Icon.why_shield,
        title = ResKey.TEMPLATE9_WHY2_TITLE,
        description = ResKey.TEMPLATE9_WHY2_DESC
    ),
    Flexible(
        icon = Template9Res.Icon.why_clock,
        title = ResKey.TEMPLATE9_WHY3_TITLE,
        description = ResKey.TEMPLATE9_WHY3_DESC
    ),
    Trusted(
        icon = Template9Res.Icon.why_star,
        title = ResKey.TEMPLATE9_WHY4_TITLE,
        description = ResKey.TEMPLATE9_WHY4_DESC
    )
}
